export default __webpack_public_path__ + "static/media/zoom.28b6f036.svg";